import {
	AssociationEntity,
	AssociationResultEntity,
	parseAssociationActivity,
	parseAssociationLocation,
	parseAssociationName,
	parseAssociationRelation
} from '../../../data';

export const convertAssociationResultToAssociations = (association: AssociationResultEntity): AssociationEntity => ({
	id: association.verenigingsnummer,
	organisationNumber: association.ondernemingsnummer ? association.ondernemingsnummer : '',
	type: {
		code: association.type.code,
		description: association.type.beschrijving
	},
	names: parseAssociationName(association.namen),
	mainActivities: association.hoofdactiviteiten.map(parseAssociationActivity),
	targetAudience: association.doelgroep
		? {
				minAge: association.doelgroep.minimumleeftijd,
				maxAge: association.doelgroep.maximumleeftijd
			}
		: null,
	locations: association.locaties.map(parseAssociationLocation),
	links: association.links,
	relations: association.relaties.map(parseAssociationRelation)
});
